import Model from '../../classes/model/Model'
import User from './User'
import qs from 'qs'

/**
 * @property {int} id
 * @property {int} $client_id
 * @property {int} $type
 * @property {string} $content
 * @property {int} $link_id
 *
 * @property {int} $created_by
 * @property {int} $updated_by
 * @property {int} $created_at
 * @property {int} $updated_at
 */
export default class ClientHistory extends Model {

    static get TYPE_VISIT () {
        return 1
    }

    static get TYPE_RESERVATION () {
        return 2
    }

    static get TYPE_CHANGE_STATUS () {
        return 3
    }

    static get TYPE_SMS_MESSAGE () {
        return 4
    }

    static get TYPE_SALE_SUBSCRIPTION () {
        return 5
    }

    static get TYPE_SALE_GOOD () {
        return 6
    }

    static get TYPE_CLOSE_DEBT () {
        return 7
    }

    static get TYPE_CHANGE_COMMENT () {
        return 8
    }

    relations () {
        return {
            creator: { class: User, many: false },
            updater: { class: User, many: false },
        }
    }

    get typeName () {
        let type = ClientHistory.getTypes().find(type => type.id === this.type)
        if (!type) {
            return ''
        }
        return type.name
    }

    static getTypes () {
        return [
            { id: ClientHistory.TYPE_VISIT, name: 'Посещение' },
            { id: ClientHistory.TYPE_RESERVATION, name: 'Бронирование' },
            { id: ClientHistory.TYPE_CHANGE_STATUS, name: 'Изменение статуса' },
            { id: ClientHistory.TYPE_SMS_MESSAGE, name: 'SMS сообщение' },
            { id: ClientHistory.TYPE_SALE_SUBSCRIPTION, name: 'Покупка абонемента' },
            { id: ClientHistory.TYPE_SALE_GOOD, name: 'Покупка товара' },
            { id: ClientHistory.TYPE_CLOSE_DEBT, name: 'Закрытие долга' },
            { id: ClientHistory.TYPE_CHANGE_COMMENT, name: 'Изменение комментария' },
        ]
    }


    static getList(clientId, page = 1, sort = undefined, perPage = 25,  extraFields = []) {

        return ClientHistory.getAxios().get(ClientHistory.getUrl('client/history-list'), {
            params: {
                page: page,
                'per-page': perPage,
                clientId: clientId,
                sort: sort,
                expand: extraFields.length > 0 ? extraFields.join(',') : undefined,
            },
            paramsSerializer: params => qs.stringify(params),
        }).then((response) => {
            let data = [];
            for (let history of response.data) {
                data.push(new ClientHistory(history));
            }
            return {data, headers: response.headers};
        });
    }

}
